import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";

import feather from "feather-icons";

@customElement("feather-icon")
export class FeatherIcon extends LitElement {
  static properties = {
    icon: { attribute: true },
  };

  static styles = css`
    .feather {
      width: 36px;
      height: 36px;
      stroke: currentColor;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
      fill: none;
    }
  `;

  constructor() {
    super();
  }

  render() {
    return html`
      ${unsafeSVG(feather.icons[this.icon].toSvg({ class: "feather" }))}
    `;
  }
}
